/**
 * Google Analytics 4. Le layout charge gtag.js et émet <meta name="iaa-ga-id"> en production
 * lorsque Site:GoogleAnalyticsId est renseigné ; sans cette balise, rien n'est envoyé à Google.
 * Signaux Google et personnalisation publicitaire désactivés (mesure d'audience uniquement).
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

let enabled = false;

// gtag.js ne traite que des objets Arguments, pas des tableaux.
function gtag(..._args: unknown[]): void {
  (window.dataLayer ??= []).push(arguments);
}

export function initGoogleAnalytics(): void {
  const id = document.querySelector<HTMLMetaElement>('meta[name="iaa-ga-id"]')?.content ?? '';
  if (!/^G-[A-Z0-9]{4,20}$/.test(id)) {
    return;
  }

  enabled = true;
  gtag('js', new Date());
  gtag('config', id, {
    allow_google_signals: false,
    allow_ad_personalization_signals: false
  });
}

export function trackGoogleEvent(event: string): void {
  if (enabled) {
    gtag('event', event);
  }
}
